import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const errorMessage = 'Не удалось изменить данные документа';

const mutationFn = ({ addressId, attachId, data, showErrorMessage = true }) => {
  return request.put(
    `Acceptance/address/${addressId}/attachment/${attachId}`,
    data,
    showErrorMessage ? errorMessage : undefined,
    'Error',
    undefined,
    undefined,
    !showErrorMessage
  );
};

export const useEditRoomAttachmentMutation = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && options?.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
  });
